/* The only static element with event handlers in this file is handling some bubbling events. */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* Sliders handles should not have keybaord evenements as it would be redundant. */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { useRef, useState } from "react";

import { CountryDropdown, RegionDropdown } from "react-country-region-selector";

import { Link, Trans, useTranslation } from "gatsby-plugin-react-i18next";

// prettier-ignore
const ALLOWED_COUNTRIES = [
  'AL', 'AD', 'AT', 'BY', 'BE', 'BA', 'BG',
  'HR', 'CZ', 'DE', 'DK', 'EE', 'FI', 'FR', 
  'GI', 'GR', 'VA', 'HU', 'IS', 'IE', 'IT',
  'LV', 'LI', 'LT', 'LU', 'MK', 'MT', 'MD',
  'MC', 'NL', 'NO', 'PL', 'PT', 'RO', 'RU',
  'SM', 'SK', 'SI', 'ES', 'SJ', 'SE', 'CH',
  'UA', 'GB', 'YU'
];

export const EMPTY_REGION = { country: "", region: "", all: false };

export const defaultLeadData = () => ({
  accept_conditions: false,
  acceptNewsletter: false,
  category: "",
  client: "",
  companyName: "",
  companyNumber: "",
  email: "",
  firstName: "",
  fleet: 0,
  frequency: 0,
  fret_range: 0,
  from: "",
  fromAll: false,
  fromCountry: "",
  fromRegion: "",
  goods: "",
  lastName: "",
  leadId: "",
  message: "",
  phoneNumber: "",
  referrals: "",
  shipping: "",
  to: "",
  toAll: false,
  toCountry: "",
  toRegion: "",
  trucks: "",
  volume: 0,
});

export const validateRequired = (errorMessage = null) => (t, content) => {
  if (!content?.length) {
    return errorMessage ?? t("sign-up.errors.this-data-is-required");
  }
};

export const validateRegion = (t, { country, region, all }) => {
  if (!country) {
    return t("sign-up.errors.area-is-required");
  } else if (country === "Europe" && !all) {
    return t("sign-up.errors.country-is-required-or-check-all-europe");
  } else if (!region && !all) {
    return t("sign-up.errors.region-is-required-or-check-all-the-country", { country });
  }
};

export const useField = (defValue, validator) => {
  const { t } = useTranslation();

  const [value, set] = useState(defValue);
  const [error, setError] = useState(null);

  return {
    value,
    set,
    error,
    setError,
    validator: val => validator(t, val ?? value),
  };
};

const fieldClassNames = erroneous =>
  Boolean(erroneous) ? "su-field su-field--erroneous" : "su-field";

export const Field = ({ label, field, children, ...props }) => {
  return (
    <label className={fieldClassNames(field.error)}>
      <span className="su-label">{label}</span>
      <input
        type="text"
        value={field.value ?? ""}
        onChange={event => {
          field.setError(null);
          field.set(event.target.value);
        }}
        onBlur={() => field.setError(field.validator())}
        {...props}
      />
      {children}
      <ErrorRenderer field={field} />
    </label>
  );
};

export const TextareaField = ({ label, field, children, ...props }) => {
  return (
    <label className={fieldClassNames(field.error)}>
      <span className="su-label">{label}</span>
      <textarea
        type="text"
        value={field.value ?? ""}
        onChange={event => {
          field.setError(null);
          field.set(event.target.value);
        }}
        onBlur={() => field.setError(field.validator())}
        {...props}
      />
      {children}
      <ErrorRenderer field={field} />
    </label>
  );
};

export const SliderField = ({ label, field, max, stepLabels }) => {
  return (
    <CustomField field={field} label={label} {...{ "data-ranges": max + 1 }}>
      <input
        type="range"
        min={0}
        max={max}
        step={1}
        value={field.value}
        onChange={e => field.set(Number(e.currentTarget.value))}
        onBlur={() => field.setError(field.validator())}
        style={{ "--val": `${(field.value / max) * 100}%` }}
      />
      <ul>
        {stepLabels.map((stepLabel, index) => (
          <li
            className={field.value === index ? "su-range-selected" : undefined}
            key={stepLabel}
            onClick={() => {
              field.set(index);
            }}>
            {stepLabel}
          </li>
        ))}
      </ul>
    </CustomField>
  );
};

export const RegionField = ({ id, label, field }) => {
  const { t } = useTranslation();

  const { country, region, all } = field.value;
  const allEurope = country === "Europe" && all;

  const changeCountry = newCountry => {
    if (newCountry !== country) {
      field.setError(null);
      field.set({ ...field.value, country: newCountry, region: "", all: false });
    }
  };
  const changeRegion = newRegion => {
    field.setError(null);
    field.set({ ...field.value, region: newRegion });
  };
  const changeAll = newAll => {
    field.setError(null);
    field.set({ ...field.value, country: country || "Europe", all: newAll });
  };

  const wrapperRef = useRef();

  return (
    <div
      className={`su-field su-field--region ${country === "France" ? "su-field--france" : ""}`}
      onBlur={() => {
        if (!document.activeElement || !wrapperRef.current.contains(document.activeElement)) {
          setTimeout(() => {
            if (
              wrapperRef.current &&
              (!document.activeElement || !wrapperRef.current.contains(document.activeElement))
            ) {
              field.setError(field.validator());
            }
          }, 300);
        }
      }}
      ref={wrapperRef}
      tabIndex={-1}>
      <span className="su-label">{label}</span>

      <div className="su-region-parent-choice">
        <input
          id={`${id}--france`}
          type="radio"
          name={id}
          value="France"
          checked={country === "France"}
          onChange={event => changeCountry(event.currentTarget.value)}
        />
        <label htmlFor={`${id}--france`}>
          <span>{t("sign-up.regions.france")}</span>
        </label>
        <input
          id={`${id}--europe`}
          type="radio"
          name={id}
          value="Europe"
          checked={country && country !== "France"}
          onChange={event => changeCountry(event.currentTarget.value)}
        />
        <label htmlFor={`${id}--europe`}>
          <span>{t("sign-up.regions.europe")}</span>
        </label>
      </div>

      {country && !allEurope && country !== "France" ? (
        <CountryDropdown
          className="su-country-dropdown"
          value={country}
          onChange={val => (val ? changeCountry(val) : changeCountry("Europe"))}
          defaultOptionLabel={t("sign-up.regions.select-country")}
          whitelist={ALLOWED_COUNTRIES.filter(country => country !== "FR")}
        />
      ) : undefined}

      {country && !all && country !== "Europe" ? (
        <RegionDropdown
          className="su-region-dropdown"
          country={country}
          value={region}
          defaultOptionLabel={t("sign-up.regions.select-region")}
          onChange={val => changeRegion(val)}
        />
      ) : undefined}

      <label className="su-checkbox-label su-whole-country">
        <input type="checkbox" checked={all} onChange={e => changeAll(e.currentTarget.checked)} />
        {t("sign-up.regions.whole-country", { country: country || "Europe" })}
      </label>

      <ErrorRenderer field={field} />
    </div>
  );
};

export const CheckboxesField = ({ label, field, choices }) => {
  return (
    <div className="su-field su-field--checkboxes">
      <span className="su-label">{label}</span>

      <ul className="su-checkbox-list">
        {Object.keys(choices).map(key => {
          const without = (field.value ?? []).filter(element => element !== key);

          return (
            <li key={key}>
              <label className="su-checkbox-label">
                <input
                  type="checkbox"
                  checked={(field.value ?? []).includes(key)}
                  onChange={e => {
                    const newValue = e.currentTarget.checked ? without.concat([key]) : without;
                    field.set(newValue);
                    field.setError(field.validator(newValue));
                  }}
                />
                {choices[key]}
              </label>
            </li>
          );
        })}
      </ul>

      <ErrorRenderer field={field} />
    </div>
  );
};

export const CustomField = ({ label, field, children, ...props }) => {
  return (
    <label className={fieldClassNames(field.error)} {...props}>
      {label ? <span className="su-label">{label}</span> : undefined}
      {children}
      <ErrorRenderer field={field} />
    </label>
  );
};

export const ErrorRenderer = ({ field, errorMessage }) => {
  const error = field?.error ?? errorMessage;

  if (error) {
    if (error.i18nKey) {
      return (
        <p className="su-error">
          {error.fieldName ? (
            <Trans
              i18nKey="sign-up.errors.field-name-prefix"
              values={{ fieldName: error.fieldName }}
            />
          ) : undefined}
          <Trans
            i18nKey={error.i18nKey}
            components={{
              loginLink: <Link to="/login" />,
              contactLink: <Link to="/contact" />,
            }}
          />
        </p>
      );
    } else {
      return <p className="su-error">{error}</p>;
    }
  } else {
    return null;
  }
};
